import { combineReducers } from 'redux'
import statistics from './statistics'

const reducer = combineReducers({
  statistics: statistics.reducer,
})

export default reducer
